import { api } from "@/redux/api";

import {
	MsdynamicsFieldsResponse,
	MsdynamicsFieldsResponseSchema,
} from "@/pages/Private/pages/Company/schema/dynamics";

/**
 * The attributes of the Dynamics campaigns and marketing lists we create, the targets of their
 * mappings (PREC-4368). Beside `dynamics.api.ts`, whose "Dynamics" cache tag it shares.
 */
export const dynamicsMarketingRecordsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getDynamicsCampaignFields: builder.query<MsdynamicsFieldsResponse, void>({
			query: () => ({
				url: "msdynamics/fields/campaigns",
				method: "GET",
				responseSchema: MsdynamicsFieldsResponseSchema,
			}),
			providesTags: ["Dynamics"],
		}),
		getDynamicsMarketingListFields: builder.query<MsdynamicsFieldsResponse, void>({
			query: () => ({
				url: "msdynamics/fields/marketing-lists",
				method: "GET",
				responseSchema: MsdynamicsFieldsResponseSchema,
			}),
			providesTags: ["Dynamics"],
		}),
	}),
});

export const { useGetDynamicsCampaignFieldsQuery, useGetDynamicsMarketingListFieldsQuery } =
	dynamicsMarketingRecordsApi;
